import { render, staticRenderFns } from "./TooltipRoot.vue?vue&type=template&id=2125409c&scoped=true&"
import script from "./TooltipRoot.vue?vue&type=script&lang=js&"
export * from "./TooltipRoot.vue?vue&type=script&lang=js&"
import style0 from "./TooltipRoot.vue?vue&type=style&index=0&id=2125409c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2125409c",
  null
  
)

export default component.exports